import { create } from 'zustand';

export const useCartStore = create((set, get) => ({
  items: [],
  
  addItem: (item) => {
    const { items } = get();
    const existingItem = items.find(i => i.id === item.id);
    
    if (existingItem) {
      set({
        items: items.map(i => 
          i.id === item.id 
            ? { ...i, quantity: i.quantity + (item.quantity || 1) }
            : i
        )
      });
    } else {
      set({ items: [...items, { ...item, quantity: item.quantity || 1 }] });
    }
  },
  
  removeItem: (itemId) => {
    set({ items: get().items.filter(i => i.id !== itemId) });
  },
  
  updateQuantity: (itemId, quantity) => {
    set({
      items: get().items.map(i => 
        i.id === itemId ? { ...i, quantity } : i
      ).filter(i => i.quantity > 0)
    });
  },
  
  clearCart: () => set({ items: [] }),
  
  getTotal: () => {
    return get().items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  },
}));
